<style media="screen" type="text/css">
</style>
<template>
  <div>
    <div v-if="$store.state.user_type != $keys.WHOLESALER">
      <shipment-status-btn
          ref="filter_status_btns"
          @update_filter="update_filter_status"
      />
    </div>
    <v-row class="mb-6">
      <v-col cols="9" md="6">
        <v-text-field
            v-model="shipment_search_query"
            :placeholder="$lang.SHIPMENT_SEARCH"
            append-icon="mdi-magnify"
            dense
            hide-details
            outlined
            rounded
            single-line
            @keyup="getShipmentList"
        ></v-text-field>
      </v-col>
      <v-col class="text-right" cols="3" md="2">
        <v-btn
            class="download-svg-btn"
            depressed
            height=""
            outlined
            rounded
            width="151px"
            @click="downloadCsv"
        >
          <img alt="" src="@/assets/download.svg"/>
          {{ $lang.DOWNLOAD_CSV }}
        </v-btn>
      </v-col>
      <v-col class="" cols="2" md="1">
        <ShippingLable :shipment_id_list="shipment_id_list" btn_type="2"></ShippingLable>
      </v-col>
      <v-col class="" cols="9" md="2">
        <div class="cursor-pointer w-max-content ml-3" @click="openFilterDialog">
          <filter-btn :filter_count="shipment_filter_data.filter_count"/>
        </div>
      </v-col>
    </v-row>
    <div>
      <v-data-table
          v-model="selected"
          :disable-sort="true"
          :headers="headers"
          :hide-default-footer="true"
          :items="shipment_list"
          :items-per-page="$keys.PAGE_LENGTH"
          :loading="table_loading"
          :single-select="singleSelect"
          class="elevation-1 custome-header-bg custome-table-body"
          item-key="shipment_id"
          show-select
      >
        <template v-slot:item.wholesaler_firm_name="{ item }">
          <p>{{ item.wholesaler_firm_name }}</p>
          <p>{{ $lang.MOBILE_PREFIX }}{{ item.wholesaler_mobile_number }}</p>
        </template>
        <!-- retailer slot -->
        <template v-slot:item.retailer_firm_name="{ item }">
          <p>{{ item.retailer_firm_name }}</p>
          <p v-if="item.retailer_mobile_number">{{ $lang.MOBILE_PREFIX }}{{ item.retailer_mobile_number }}</p>
          <p>({{ item.retailer_location }})</p>
        </template>
        <!-- status  -->
        <template v-slot:item.shipment_status="{ item }">
          <change-status-dropdown
              v-if="$store.state.user_type != $keys.WHOLESALER"
              :shipment="item"
          />
          <span
              v-if="$store.state.user_type == $keys.WHOLESALER"
              :class="getClassSatus(item.shipment_status)"
          >{{ item.shipment_status }}</span
          >
        </template>
        <!--  -->
        <!-- action btn set -->
        <!--  -->
        <template v-slot:item.action="{ item }">
          <!--  for  the wholesaler -->
          <span v-if="$store.state.user_type == $keys.WHOLESALER">
            <v-btn
                fab
                small
                text
                @click="printShipmentDetails(item.shipment_id)"
            >
              <v-icon color="#6D7C8E" small> mdi-printer</v-icon>
            </v-btn>
          </span>
          <!-- for Admin and ware house angent  -->
          <span v-else>
            <v-btn
                v-if="
                [
                  $keys.CONFIRMATION_PENDING,
                  $keys.CONFIRMED,
                  $keys.DROPPED_AT_WAREHOUSE,
                ].includes(item.shipment_status)
              "
                fab
                small
                text
                @click="
                confirmChangeShipmentstatus(item.shipment_id, $keys.CANCELLED)
              "
            >
              <img alt="" src="@/assets/return-orange.svg" width="18px"/>
            </v-btn>
            <div style="display: inline-block">

                <ShippingLable :shipment_id="item.shipment_id" :shipment_id_list="JSON.stringify([item.shipment_id])"
                               btn_type="3"></ShippingLable>
                          </div>

          </span>
          <v-btn fab small text @click="gotoShipmentDetails(item)">
            <img alt="" src="@/assets/arrow-right.svg"/>
          </v-btn>
        </template>

        <!--empty state  -->
        <template v-slot:no-data>
          <empty-list :message="$lang.EMPTY_SHIPMENTS"/>
        </template>
      </v-data-table>

      <v-pagination
          v-model="page_number"
          :length="total_page_count"
          :total-visible="7"
          class="custome-pagination"
          @input="getShipmentList"
      ></v-pagination>

      <!-- <shipment-list/> -->

      <shipment-filter
          ref="shipmet_filter_dialog"
          :dialog="filter_dialog"
          :filter_data="filter_data"
          @filter="getShipmentList"
      />
    </div>

    <common-confirmation-dialog
        :YesClickHanler="cancelShipment"
        :dialog="dialog"
    />
  </div>
</template>

<script type="text/javascript">
import {mapGetters} from 'vuex';


export default {
  components: {
    // ShipmentFilter :()=>import('@/components/common-components/ShipmentFilter.vue'),
    ShipmentFilter: () => import("./child/ShipmentFilter.vue"),
    FilterBtn: () => import("@/components/common-components/FilterBtn.vue"),
    ShipmentStatusBtn: () => import("./child/ShipmentStatusBtn.vue"),
    ChangeStatusDropdown: () => import("./child/ChangeStatusDropdown.vue"),
    CommonConfirmationDialog: () =>
        import("@/components/common-components/CommonConfirmationDialog.vue"),
    ShippingLable: () =>
        import("@/components/common-components/ShippingLable.vue"),
  },
  watch: {
    selected: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.getShipmentIdList();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      pdf_url: "",
      pdf: "",
      total_page_count: 1,
      page_number: 1,
      table_loading: false,
      shipment_list: [],
      selected: [],
      shipment_id_list: [],
      singleSelect: false,
      shipment_search_query: "",
      headers: [
        {text: "Date", align: "start", value: "shipment_date"},
        {text: "Shipment ID", align: "start", value: "shipment_id"},
        {text: "Wholesaler Info", value: "wholesaler_firm_name"},
        {text: "Retailer Info", value: "retailer_firm_name"},
        {text: "Challan", value: "challan_number"},
        // { text: 'Amount', value: 'shipment_amount' },
        {text: "Status", value: "shipment_status"},
        {text: "", value: "action", align: "end", width: "180px"},
      ],
      filter_dialog: {
        flag: false,
      },
      dialog: {
        shipment_id: "",
        flag: false,
      },
      filter_data: {
        retailer_id_list: [],
        wholesaler_id_list: [],
        status_list: [],
        type_list: [],
        filter_date_from: [],
        filter_date_to: [],
        filter_count: [],
      }


    };
  },
  computed: mapGetters({
    shipment_filter_data: "shipment/getShipmentFilter",
  }),
  created() {
    if (this.$route.query.shipment_status) {
      let shipment_status = this.decrypt(this.$route.query.shipment_status);
      shipment_status = shipment_status.split(",");
      setTimeout(() => {
        this.$refs.filter_status_btns.selected_status = shipment_status;
        this.update_filter_status(shipment_status);
      }, 500);
    } else this.getShipmentList(false);

    this.$store.dispatch("drawer/setActiveTab", this.$route.name);
    this.$store.dispatch("setPageLoader", true);
  },
  methods: {
    /*Open filter dialog*/
    openFilterDialog() {
      console.log("methods_11");
      this.$refs.shipmet_filter_dialog.getWholesalerList()
      this.filter_data.retailer_id_list = this.shipment_filter_data.retailer_id_list
      this.filter_data.wholesaler_id_list = this.shipment_filter_data.wholesaler_id_list
      this.filter_data.status_list = this.shipment_filter_data.status_list
      this.filter_data.type_list = this.shipment_filter_data.type_list
      this.filter_data.filter_date_from = this.shipment_filter_data.filter_date_from
      this.filter_data.filter_date_to = this.shipment_filter_data.filter_date_to
      this.filter_dialog.flag = true;

    },
    /* fetching shipment list */
    getShipmentList(is_cancel = true) {
      console.log("methods_12");
      const self = this;
      self.table_loading = true;
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        search_query: this.shipment_search_query,
        filter_retailer_id_list: JSON.stringify(
            this.shipment_filter_data.retailer_id_list
        ),
        wholesaler_id_list: JSON.stringify(this.shipment_filter_data.wholesaler_id_list),
        filter_status_list: JSON.stringify(this.shipment_filter_data.status_list),
        filter_type_list: JSON.stringify(this.shipment_filter_data.type_list),
        filter_date_from: this.shipment_filter_data.filter_date_from,
        filter_date_to: this.shipment_filter_data.filter_date_to,
      };
      console.log(params);
      const successHandler = (response) => {
        if (response.data.success) {
          self.shipment_list = response.data.shipment_list;
          self.total_page_count = response.data.total_page_count;
        }
      };
      const finallyHandler = () => {
        self.table_loading = false;
        self.$store.dispatch("setPageLoader", false);
      };

      self.request_GET(
          self,
          self.$urls.SHIPMENT_LIST,
          params,
          successHandler,
          null,
          null,
          finallyHandler,
          is_cancel
      )
      ;
    },
    /* print shipment details */
    // printShipmentDetails(shipment_id) {
    //   console.log("methods_13");
    //
    //   this.$store.dispatch("setPageLoader", true);
    //   const self = this;
    //   const reqListener = () => {
    //     var arrayBuffer = xhr.response;
    //     var fileURL = URL.createObjectURL(xhr.response);
    //     window.open(fileURL);
    //     this.$store.dispatch("setPageLoader", false);
    //   };
    //
    //   let url =
    //       this.$urls.BASE_URL + "shipment/get-pdf/?shipment_id=" + shipment_id + "&user_type=" + this.$store.state.user_type;
    //   var xhr = new XMLHttpRequest();
    //   xhr.addEventListener("load", reqListener);
    //   xhr.open("GET", url);
    //   xhr.responseType = "blob";
    //   xhr.overrideMimeType("application/pdf; charset=x-user-defined");
    //   xhr.send();
    // },
    // bulkPrint() {
    //   if (this.selected.length == 0) {
    //     this.showSnakeBar("warning", this.$messages.NO_SHIPMENT_SELECTED);
    //     return false;
    //   }
    //   this.$store.dispatch("setPageLoader", true);
    //   const self = this;
    //   const reqListener = () => {
    //     var arrayBuffer = xhr.response;
    //     var fileURL = URL.createObjectURL(xhr.response);
    //     window.open(fileURL);
    //     this.$store.dispatch("setPageLoader", false);
    //   };
    //
    //   let url =
    //       this.$urls.BASE_URL + "shipment/get-bulk-pdf/?shipment_id_list=" + this.shipment_id_list + "&user_type=" + this.$store.state.user_type;
    //   var xhr = new XMLHttpRequest();
    //   xhr.addEventListener("load", reqListener);
    //   xhr.open("GET", url);
    //   xhr.responseType = "blob";
    //   xhr.overrideMimeType("application/pdf; charset=x-user-defined");
    //   xhr.send();
    // },
    /* get shipment id list for selected shipment */
    getShipmentIdList() {
      console.log("methods_14");
      this.shipment_id_list = [];
      for (let i = 0; i < this.selected.length; i++) {
        this.shipment_id_list.push(this.selected[i].shipment_id);
      }
      this.shipment_id_list = JSON.stringify(this.shipment_id_list);
    },
    /* refresh list with quick filters */
    update_filter_status(status) {
      console.log("methods_15");
      this.filter_data.status_list = [];
      if (status) this.filter_data.status_list = status;
      this.$refs.shipmet_filter_dialog.manageCount();
      this.$refs.shipmet_filter_dialog.applyFilter();
    },
    /* Open confimation dialog for cancelation */
    confirmChangeShipmentstatus(shipment_id, status) {
      console.log("methods_16");

      this.dialog.id = shipment_id;
      this.dialog.name = shipment_id;
      this.dialog.flag = true;
      this.dialog.status = status;
      this.dialog.msg = "want to change shipment status to " + status;
    },

    /* cancelt shipment Api call*/
    cancelShipment() {
      console.log("methods_17");

      const self = this;
      var form = new FormData();
      form.append("shipment_id", this.dialog.id);
      form.append("shipment_status", this.dialog.status);
      const successHandler = (response) => {
        self.dialog.flag = false;
        self.dialog.btn_loading = false;
        this.dialog.shipment_id = "";
        this.dialog.flag = false;
        self.getShipmentList();
      };
      const finallyHandler = () => {
      };
      this.request_POST(
          self,
          self.$urls.CHANGE_SHIPMENT_STATUS,
          form,
          successHandler,
          null,
          null,
          finallyHandler
      );
    },
    /* Download CSV*/
    downloadCsv() {
      console.log("methods_18");
      if (this.selected.length == 0) {
        this.showSnakeBar("warning", this.$messages.NO_SHIPMENT_SELECTED);
        return false;
      }
      window.open(
          this.$urls.BASE_URL +
          this.$urls.SHIPMENT_CSV +
          "?shipment_id_list=" +
          this.shipment_id_list,
          "_blank"
      );
    },
  },
};
</script>